import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-splash-container',
  templateUrl: './splash-container.component.html',
  styleUrls: ['./splash-container.component.scss']
})
export class SplashContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
